import type { ReactNode } from 'react';
import { cn } from 'lib/utils';

interface AccountRowProps {
  title: string;
  hint?: string;
  children: ReactNode;
  isLast?: boolean;
}

/** Label on the left half, control on the right half; stacks on phones. */
export function AccountRow({ title, hint, children, isLast = false }: AccountRowProps) {
  return (
    <div
      className={cn(
        'flex flex-col gap-3 py-3.5 sm:flex-row sm:items-center sm:gap-6',
        !isLast && 'border-b border-grey-100 dark:border-border'
      )}
    >
      <div className="flex min-w-0 flex-col gap-0.5 sm:w-1/2">
        <p className="text-sm font-medium leading-body text-grey-950 dark:text-foreground">
          {title}
        </p>
        {hint ? (
          <p className="text-xs leading-heading text-grey-500 dark:text-muted-foreground">{hint}</p>
        ) : null}
      </div>
      <div className="flex min-w-0 sm:w-1/2">{children}</div>
    </div>
  );
}
